import {
  CarePlanManifestationResponse,
  CarePlanProblemResponse,
} from '~/lib/types/carePlan/carePlans';
import {
  ChakraFlex,
  FAIconName,
  FireflyKebabMenu,
  FireflyKebabMenuItem,
  Icon,
  Text,
} from '@equip.health/ui';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { CarePlanFrequencyTooltipIcon } from '~/components/maud/patients/profile/tabs/careplan/CarePlanFrequencyTooltipIcon';
import { NOT_YET_ASSESSED_FREQUENCY_CODES } from '~/lib/constants/carePlan.constants';

type Props = {
  problem: CarePlanProblemResponse;
  manifestation: CarePlanManifestationResponse;
  onEditProblemClick: () => void;
};
export const CarePlanGoalCardManifestationRow = ({
  problem,
  manifestation,
  onEditProblemClick,
}: Props) => {
  const {
    carePlanNotesDisplay: isCarePlanNotesDisplayEnabled,
    manifestationProblemStatusFrequency: isManifestationStatusFrequencyEnabled,
  } = useFlags<LDFlags>();

  const kebabMenuOptions: FireflyKebabMenuItem[] = [
    {
      label: 'Edit problem',
      leftIcon: FAIconName.penRegular,
      onClick: onEditProblemClick,
    },
  ];

  return (
    <ChakraFlex
      alignItems="center"
      background="neutral.background.secondary"
      borderRadius="12px"
      justifyContent="space-between"
      padding="12px"
      width="100%"
    >
      <ChakraFlex direction="column">
        <ChakraFlex alignItems="center" direction="row" gap="10px">
          <Text variant="body">{problem.pathwayProblem.label}</Text>
          <Icon
            color="accent.blue"
            name={FAIconName.arrowRightRegular}
            size="sm"
          />
          <Text variant="bodyMedium">
            {manifestation.pathwayManifestation.label}
          </Text>
        </ChakraFlex>
        {!!manifestation.description && (
          <Text color="neutral.secondary" marginTop="4px" variant="caption">
            {manifestation.description}
          </Text>
        )}
      </ChakraFlex>
      <ChakraFlex alignItems="center" gap="12px">
        {isManifestationStatusFrequencyEnabled && manifestation.frequency && (
          <CarePlanFrequencyTooltipIcon
            createdByUserId={manifestation.frequency.createdByUserId}
            effectiveDate={manifestation.frequency.effectiveDate}
            frequencyLabel={manifestation.frequency.label}
            id={`care-plan-manifestation-${manifestation.pathwayManifestation.code}`}
            label={
              manifestation.pathwayManifestation.providerFacingLanguage ??
              manifestation.pathwayManifestation.label
            }
            showChangeDetails={
              isCarePlanNotesDisplayEnabled &&
              !NOT_YET_ASSESSED_FREQUENCY_CODES.includes(
                manifestation.frequency.code,
              )
            }
          />
        )}
        {isManifestationStatusFrequencyEnabled &&
          manifestation.frequency === null &&
          manifestation.statusCode === 'RESOLVED' && (
            <Text variant="body">Resolved</Text>
          )}
        <FireflyKebabMenu
          aria-label="Manifestation menu"
          options={kebabMenuOptions}
        />
      </ChakraFlex>
    </ChakraFlex>
  );
};
